import * as React from 'react'
import { FaXTwitter } from 'react-icons/fa6'
import { FacebookIcon, LinkedinIcon } from 'react-share'

import { Button } from '@/components/custom/button'

import { generateSocialShareUrl } from '@/utils/seo-utils'

interface GroupSharingButtonProps {
  url?: string
  title?: string
  description?: string
  hashtags?: string[]
  className?: string
}

export default function GroupSharingButton({
  url,
  title = '',
  description = '',
  hashtags = [],
  className = '',
}: GroupSharingButtonProps) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '')

  // For react-share library, we need to use the hashtag prop for Facebook
  // and create custom handlers for better control
  const handleFacebookShare = () => {
    const facebookShareUrl = generateSocialShareUrl(shareUrl, 'facebook', {
      title,
      description,
      hashtags,
    })
    window.open(facebookShareUrl, '_blank', 'width=600,height=400')
  }

  const handleLinkedInShare = () => {
    const linkedInShareUrl = generateSocialShareUrl(shareUrl, 'linkedin', {
      title,
      description,
      hashtags,
    })
    window.open(linkedInShareUrl, '_blank', 'width=600,height=400')
  }

  const handleTwitterShare = () => {
    const twitterShareUrl = generateSocialShareUrl(shareUrl, 'twitter', {
      title,
      description,
      hashtags,
    })
    window.open(twitterShareUrl, '_blank', 'width=600,height=400')
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Button variant="outline" size="icon" className="border-none shadow-none">
        <div
          onClick={handleFacebookShare}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleFacebookShare()
            }
          }}
          role="button"
          tabIndex={0}
          aria-label={`Share "${title}" on Facebook`}
          className="transition-transform hover:scale-110 cursor-pointer"
        >
          <FacebookIcon size={25} round />
        </div>
      </Button>
      <Button variant="outline" size="icon" className="border-none shadow-none">
        <div
          onClick={handleLinkedInShare}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleLinkedInShare()
            }
          }}
          role="button"
          tabIndex={0}
          aria-label={`Share "${title}" on LinkedIn`}
          className="transition-transform hover:scale-110 cursor-pointer"
        >
          <LinkedinIcon size={25} round />
        </div>
      </Button>
      <Button variant="outline" size="icon" className="border-none shadow-none">
        <div
          onClick={handleTwitterShare}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleTwitterShare()
            }
          }}
          role="button"
          tabIndex={0}
          aria-label={`Share "${title}" on X`}
          className="transition-transform hover:scale-110 cursor-pointer"
        >
          <FaXTwitter size={25} />
        </div>
      </Button>
    </div>
  )
}
